var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIssueImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.8801C7.18845 10.8801 7.34643 10.8163 7.47394 10.6888C7.60145 10.5613 7.66521 10.4033 7.66521 10.2149C7.66521 10.0264 7.60145 9.86842 7.47394 9.74091C7.34643 9.61354 7.18845 9.54985 7 9.54985C6.81155 9.54985 6.65357 9.61354 6.52606 9.74091C6.39855 9.86842 6.33479 10.0264 6.33479 10.2149C6.33479 10.4033 6.39855 10.5613 6.52606 10.6888C6.65357 10.8163 6.81155 10.8801 7 10.8801ZM6.38235 8.01356H7.61765V3.04068H6.38235V8.01356ZM4.08594 14L0 9.91776V4.08594L4.08224 0H9.91406L14 4.08224V9.91406L9.91776 14H4.08594Z",
    fill: "#172B4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssueImage);
export default __webpack_public_path__ + "static/media/issue_image.baa8d78acd3522174c866467d6cea792.svg";
export { ForwardRef as ReactComponent };